import { Component, input, InputSignal } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';
import { ModalCloseDirective } from '../modal/components/modal-close/modal-close-button.directive';

/**
 * The Confirm OK Button Component
 *
 * This component will close modal window with a reason hardcoded to 'ok'.
 */
@Component({
  imports: [
    TranslateDirective,
    ButtonComponent,
    ModalCloseDirective
  ],
  selector: 'td-wb-confirm-button-ok',
  templateUrl: 'confirm-button-ok.component.html',
  styleUrls: ['confirm-button-ok.component.scss']
})
export class ConfirmButtonOkComponent {
  readonly value: InputSignal<string> = input<string>('OK');
}
